import { Injectable } from '@angular/core';

// external libs
import { Observable } from 'rxjs';

// services
import { MarkerClusterService } from '../abstract/abstract-marker-cluster';

// directives
import { H21MapMarkerClusterDirective } from '../../directives/h21-map-marker-cluster.directive';

// models
import { CircleEvent } from '../../models/circle-event.model';
import { MarkerClusterFilter } from '../../models/marker-cluster-filter.model';

@Injectable()
export class BaiduMarkerClusterService extends MarkerClusterService<BMap.Map, BMap.Marker, BMap.Polyline> {

    public removeMarkerCluster(layer: H21MapMarkerClusterDirective): void {

    }

    public removeFeature(layer: H21MapMarkerClusterDirective): void {

    }

    public updateMarkerCluster(layer: H21MapMarkerClusterDirective): void {
    }

    public addMarkerCluster(layer?: H21MapMarkerClusterDirective): void {

    }

    public removeMarkerClusters(): void {

    }
    public createEvent<E>(eventName: string, layer: H21MapMarkerClusterDirective): Observable<E> {
        return null;
    }
    public createEventMouseOver<D>(layer: H21MapMarkerClusterDirective): Observable<D> {
        return null;
    }
    public createEventMouseOut<D>(layer: H21MapMarkerClusterDirective): Observable<D> {
        return null;
    }
    public createEventMouseClick<DE>(layer: H21MapMarkerClusterDirective): Observable<DE> {
        return null;
    }

    public setModeCircle(CircleOptions: CircleEvent): void {
        this.modeCircle.next(CircleOptions);
    }

    public setFilter(filter: MarkerClusterFilter): void {
        this.changeFilter.next(filter);
    }

    public updateStyle(id: number): void { }

    public getBounds(): any { }

    public clearMarkerCluster(): void {
    }

}
